import { getConfidenceClass } from "../../Document/getConfidenceClass";
import { DataPointValue, State } from "../../types";
import { newDefaultValue } from "../util";

export type AddValueAction<T> = Readonly<{
  copyValue: DataPointValue<T> | null;
  dataPointKey: string;
  key: string;
  type: "ADD VALUE";
}>;

export const addValue = <T>(state: State, action: AddValueAction<T>): State => {

  if (action.copyValue === null) {
    return {
      ...state,
      activeValue: action.key,
      modified: true,
      values: {
        ...state.values,
        [action.key]: newDefaultValue(action.dataPointKey, action.key),
      },
    };
  }

  if (!(action.copyValue.valueKey in state.values)) {
    return state;
  }

  const values = {
    ...state.values,
    [action.key]: {
      ...action.copyValue,
      confidence: 1.0,
      valueKey: action.key,
    },
  };
  let blocks = state.blocks;
  const idRef = action.copyValue.idRef;
  if (idRef !== null && idRef in blocks && !blocks[idRef].references.includes(action.key)) {
    const newBlock = {
      ...blocks[idRef],
      references: blocks[idRef].references.concat([action.key]),
    };
    blocks = {
      ...blocks,
      [idRef]: {
        ...newBlock,
        confidenceClass: getConfidenceClass(newBlock, state.confidenceThreshold, values),
      },
    };
  }
  return {
    ...state,
    activeValue: action.key,
    blocks,
    modified: true,
    values,
  };
};
